import { JobType } from './job.type';
import { IStepRequest } from './job-request.model';

export class NoParamJobRequest implements IStepRequest {
	stepFunctionType: Exclude<JobType, 'de-nist'| 'deduplicate-docs'>;

	constructor(params?: NoParamJobRequestParams<Exclude<JobType, 'de-nist'| 'deduplicate-docs'>>) {
		this.stepFunctionType = params?.type;
	}
}

interface NoParamJobRequestParams<T> {
	type: T;
}


